import service from '@/utils/request'
// 1、 返回一个唯一的标识符
export const jsuuid =()=>{
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
    })
}
// 2、 返回系统日期的标识符
export const uuid =()=>{ 
  var d = new Date()
  var time = d.getFullYear() + "-" +(d.getMonth()+1) + "-" + d.getDate() + "-" + d.getHours() + "-" + d.getMinutes() + "-" + d.getSeconds();
  return time
}
//3 、两位数，不够补0
const getHandledValue = num => {
  return num < 10 ? '0' + num : num
}
//4 、返回系统当前日期
export const getDate = (startType) => {
  const d = new Date()
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1)
  const date = getHandledValue(d.getDate())
  const hours = getHandledValue(d.getHours())
  const minutes = getHandledValue(d.getMinutes())
  const second = getHandledValue(d.getSeconds())
  let resStr = ''
  if (startType === 'full') resStr = year +'-'+ month + '-'+ date  +' '+ hours +':'+ minutes +':'+ second
  else if (startType === 'hour') resStr =   hours +':'+ minutes +':'+ second
  else if (startType === 'yr')  resStr = year+''
  else if (startType === 'year')  resStr = year+'-01-01'
  else resStr = year + '-' + month + '-' + date
  return resStr
}  
//5、返回系统当前日期 多少天之后的日期
export const getDate2 = (day) => {
  const d = new Date(new Date().getTime()-day*24*60*60*1000) 
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1)
  const date = getHandledValue(d.getDate())
  let resStr =  year + '-' + month + '-' + date
  return resStr
} 
 
//6 、返回 日期 ：参数1 ：日期参数 ， 参数2：隔多少天
export const getDateAdd = (strDate,addNum) => {
  const d = new Date(new Date(strDate).getTime() +addNum*24*60*60*1000) 
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1)
  const date = getHandledValue(d.getDate())
  let resStr =  year + '-' + month + '-' + date
  return resStr
} 
//7、两个日期 相差秒数
export const getSecond = (frDate,toDate) => {
    const d =  new Date(toDate).getTime() - new Date(frDate).getTime() 
    let resStr =  d /1000  
    return resStr
} 
export const formateDay = (date) => {
  const year = date.getFullYear()
  const month = getHandledValue(date.getMonth() + 1)
  const day = getHandledValue(date.getDate())
  let resStr =  year + '-' + month + '-' + day
  return resStr
}
export const formateHour = (date) => {
  const year = date.getFullYear()
  const month = getHandledValue(date.getMonth() + 1)
  const day = getHandledValue(date.getDate())
  const hours = getHandledValue(date.getHours())
  const minutes = getHandledValue(date.getMinutes())
  let resStr =  year + '-' + month + '-' + day+' '+hours+':'+minutes
  return resStr
}
//
export const getRecNum =(username_ ) =>{
  return service('xuper_auth/getRecordCnt', {
    method:'post',
    data:{p_key:'userno',p_value:username_,p_key2:'stfg',p_value2:'N',p_table:'v_sys_user'}
  })
}
